export const ROOT_RESET_REDUCER_STATE_TO_DEFAULT = 'ROOT_RESET_REDUCER_STATE_TO_DEFAULT';
